module.exports = __webpack_public_path__ + "img/gift.3357ad64.svg";